import { render } from "./AlertComponent.vue?vue&type=template&id=b50615f8&ts=true"
import script from "./AlertComponent.vue?vue&type=script&lang=ts"
export * from "./AlertComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__